import React, { useEffect, useContext, useState, useRef } from 'react'
import { debounce } from 'lodash';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Box } from '@material-ui/core'

import completedFormatIcon from '../../../images/completedFormatIcon.svg'


const ScaleThumbForm = ({ onClick, completedIcon, isEditor, grabCursor, children }) => {

  const [scale, setScale] = useState(0)

  const theme = useTheme();
  const mediaQueryUpMd = useMediaQuery(theme.breakpoints.up('md'));
  const mediaQueryUpSm = useMediaQuery(theme.breakpoints.up('sm'));
  const observedElementRef = useRef(null)
  useEffect(() => {
    if (observedElementRef.current) {
      const observer = new ResizeObserver(debounce((entries) => {
        for (let entry of entries) {
          let width = observedElementRef.current?.getBoundingClientRect()?.width
          let height = observedElementRef.current?.getBoundingClientRect()?.height

          let widthToGo = 600
          if (mediaQueryUpSm) {
            widthToGo = 1500
          }

          let newScale = width/widthToGo
          setScale(newScale)
        }
      }));
      observer.observe(observedElementRef?.current);
      return () => {
          observer.disconnect();
      };
    }
  }, [observedElementRef?.current, mediaQueryUpSm]);

  return (
    <Box
      ref={observedElementRef}
      sx={{
        aspectRatio:"1.5",
        flex:1,
        overflow:"hidden",
        position:"relative",
        cursor:grabCursor ? "grab" : onClick?"pointer":"default",
      }}
      onClick={onClick?onClick:null}
    >
      <Box sx={{
        width:["600px", "1500px"],
        height:["400px", "1000px"],
        transform:"scale("+scale+")",
        transformOrigin:"top left",
        backgroundColor:"background.grey"
      }}>
        {children}
      </Box>
      {!isEditor &&
        <Box sx={{
          background:"rgba(0,0,0,0.1)",
          width:"100%",
          height:"100%",
          position:"absolute",
          top:0,
          left:0,
        }} />
      }
      {completedIcon &&
        <Box sx={{
          width:"100%",
          height:"100%",
          position:"absolute",
          top:0,
          left:0,
          display:"flex",
          justifyContent:["center", "center", "flex-end"],
          alignItems:["center", "center", "flex-start"],
          padding:["0", "0", "10px"],
          userSelect:"none",
        }}>
          <Box
            sx={{
              width:["20px", "20px", "25px"],
              minWidth:["20px", "20px", "25px"],
            }}
          >
            <img
              src={completedFormatIcon}
              style={{width:"100%"}}
            />
          </Box>
        </Box>
      }
    </Box>
  )
}

export default ScaleThumbForm
